import { Box, Button, Grid, IconButton, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialTypography from "../../../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../../../components/MaterialInput";
import MaterialBox from "../../../../../../../components/MaterialBox";
import MaterialSelect from "../../../../../../../components/MaterialSelect";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Visibility from "@mui/icons-material/Visibility";
import axios from "axios";
import { BASE_URL, fetchData } from "../../../../../../Utils/Baseurl";
import StakeHolder from "../../../../../../StakeHolder";
import MultiSelectAutocomplete from "../../../../../../../components/MultiSelectAutocomplete";

const SubtaskAddForm = ({
  subTask,
  setSubTask,
  data,
  editdata,
  stakeholderdata,
  view,
}) => {
  const [employeeList, setEmployeeList] = useState([]);
  const [teamsOption, setTeamsOption] = useState([]);
  const [isdata, setisdata] = useState(false);

  useEffect(() => {
    fetchProjectResources();
    fetchTeamsData();
  }, []);

  useEffect(() => {
    if (editdata == true) {
      setTimeout(() => {
        const filteredEmployees = employeeList.filter((emp) =>
          stakeholderdata.some((stakeholder) => stakeholder.user_id == emp.id)
        );
        setSubTask({
          ...subTask,
          stackholder: filteredEmployees,
        });
      }, 1000);
    }
  }, [isdata]);

  const fetchProjectResources = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(
        `${BASE_URL}api/project-resource/${data?.project}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data.data, "console of the resource API ");
      setEmployeeList(response.data.data);
      setisdata(true);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTeamsData = async () => {
    const data = await fetchData("api/teams/");

    const status = data?.status;
    if (status) {
      setTeamsOption(data?.data);
    } else {
      setTeamsOption([]);
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSubTask((prev) => ({
      ...prev,
      attachments: [...prev.attachments, ...files],
    }));
  };

  const handleDeleteAttachment = (indexToDelete) => {
    setSubTask((prev) => ({
      ...prev,
      attachments: prev.attachments.filter(
        (_, index) => index !== indexToDelete
      ),
    }));
  };

  const handleChangeSubTask = (e) => {
    const { name, value } = e.target;

    setSubTask((prev) => {
      const updated = { ...prev, [name]: value };

      switch (name) {
        case "subTaskName":
          const alphaNumericRegex = /^[a-zA-Z0-9 ]*$/;
          updated.subTaskNameStatus =
            value && alphaNumericRegex.test(value) ? "success" : "error";
          break;

        case "startDate":
          updated.startDateStatus =
            value && value !== prev.endDate ? "success" : "error";
          break;

        // case "endDate":
        //   updated.endDateStatus =
        //     value && value !== prev.startDate ? "success" : "error";
        //   break;
        // case "startDate":
        //   updated.startDateStatus =
        //     value && new Date(value) <= new Date() ? "success" : "error";
        //   break;

        case "endDate":
          updated.endDateStatus =
            value && new Date(value) >= new Date(prev.startDate)
              ? "success"
              : "error";
          break;

        case "assignedHours":
          const hoursRegex = /^[0-9]*$/;
          updated.assignedHoursStatus =
            value && hoursRegex.test(value) ? "success" : "error";
          break;

        case "description":
          updated.descriptionStatus = value.length <= 300 ? "success" : "error";
          break;

        default:
          if (name === "assignee") {
            updated.assigneeStatus = value ? "success" : "error";
          }
          if (name === "teams") {
            updated.teamsStatus = value ? "success" : "error";
          }
          break;
      }

      return updated;
    });
  };

  const handleChangeSubTaskhours = (e) => {
    const { name, value } = e.target;

    const hoursRegex = /^[0-9]*$/;

    setSubTask((prev) => ({
      ...prev,
      [name]: value,
      hoursStatus: value && hoursRegex.test(value) ? "success" : "error",
    }));
  };
  const handleResourceChange = (selectedEmployee) => {
    setSubTask((prev) => ({
      ...prev,
      assignee: selectedEmployee,
      assigneeStatus: selectedEmployee ? "success" : "error",
    }));
  };
  const handleTeamschange = (selectedEmployee) => {
    console.log("selectedEmployee", selectedEmployee);
    setSubTask((prev) => ({
      ...prev,
      teams: selectedEmployee,
      teamsStatus: selectedEmployee ? "success" : "error",
    }));
  };

  const handleMultipleSelect = (event, newValue) => {
    setSubTask({
      ...subTask,
      stackholder: newValue,
    });
  };

  const handledeleteattach = () => {
    setSubTask({
      ...subTask,
      attachments: [],
    });
  };

  const handleview = (url) => {
    window.open(BASE_URL + url, "_blank");
  };

  return (
    <Grid container spacing={2} p={1}>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            Sub-task Name<span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="subTaskName"
            placeholder="Enter sub-task name"
            value={subTask.subTaskName}
            onChange={handleChangeSubTask}
            error={subTask.subTaskNameStatus === "error"}
            success={subTask.subTaskNameStatus === "success"}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            Teams<span style={{ color: "red" }}>*</span>
          </MaterialTypography>

          <MaterialSelect
            name="teams"
            value={subTask?.teams}
            customStyles={{ optionPadding: 20 }}
            //   isDisabled={subTask?.projectName ? inputDisble : true}
            options={employeeList?.map((item) => {
              return {
                value: item?.id,
                label: item?.team,
              };
            })}
            onChange={handleTeamschange}
            isClearable
            error={subTask?.teamsStatus === "error" ? true : false}
            success={subTask?.teamsStatus === "success" ? true : false}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            Assignee<span style={{ color: "red" }}>*</span>
          </MaterialTypography>

          <MaterialSelect
            name="assignee"
            placeholder="Select the employee"
            value={subTask.assignee}
            isDisabled={subTask.teams?.value == undefined}
            options={employeeList
              ?.filter((x) => x.team === subTask.teams?.label)
              .map((emp) => ({
                value: emp.id,
                label: emp.employee_name,
              }))}
            onChange={handleResourceChange}
            error={subTask.assigneeStatus === "error"}
            success={subTask.assigneeStatus === "success"}
          />
        </Stack>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            Stake Holder
          </MaterialTypography>
          <MultiSelectAutocomplete
            id="employee-selector"
            placeholder="Add employees"
            options={employeeList}
            value={subTask?.stackholder}
            onChange={handleMultipleSelect}
            labelKey="employee_name"
          />
        </Stack>
      </Grid>
      {/* <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction='column' spacing={0.5}>
                    <MaterialTypography variant='caption' color='text'>Stackholder Name</MaterialTypography>
                    <MaterialSelect
                        name='stackholder'
                        placeholder='Select the stackholder'
                        value={subTask.stackholder}
                        error={subTask.stackholderStatus === 'error'}
                        success={subTask.stackholderStatus === 'success'}
                    />
                </Stack>
            </Grid> */}
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            Assigned hours<span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="hours"
            placeholder="Enter assigned hours"
            value={subTask.hours}
            onChange={handleChangeSubTaskhours}
            error={subTask.hoursStatus === "error"}
            success={subTask.hoursStatus === "success"}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            Stat date<span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="startDate"
            type="date"
            placeholder="Enter the start date"
            value={subTask.startDate}
            onChange={handleChangeSubTask}
            error={subTask.startDateStatus === "error"}
            success={subTask.startDateStatus === "success"}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            End date<span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="endDate"
            type="date"
            placeholder="Enter the end date"
            value={subTask.endDate}
            onChange={handleChangeSubTask}
            error={subTask.endDateStatus === "error"}
            success={subTask.endDateStatus === "success"}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            Description<span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="description"
            placeholder="Enter the description"
            multiline
            rows={4}
            value={subTask.description}
            onChange={handleChangeSubTask}
            error={subTask.descriptionStatus === "error"}
            success={subTask.descriptionStatus === "success"}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <Stack direction="column" spacing={0.5}>
          <MaterialTypography variant="caption" color="text">
            Attachments
          </MaterialTypography>
          {subTask.attachments?.length == 0 && (
            <label htmlFor="file-upload">
              <input
                id="file-upload"
                type="file"
                hidden
                multiple
                onChange={handleFileChange}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px dotted #159eed",
                  width: "auto",
                  height: "100px",
                  borderRadius: "20px",
                  backgroundColor: "#edf2fb",
                }}
              >
                <IconButton component="span" color="dark">
                  <UploadFileIcon sx={{ width: "50px", height: "50px" }} />
                </IconButton>
              </Box>
            </label>
          )}

          {subTask.attachments?.length > 0 && (
            <Stack spacing={0.5} mt={1}>
              {!subTask.attachments?.includes("task_attachments") ? (
                <>
                  {subTask.attachments?.map((file, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        border: "1px solid #ddd",
                        borderRadius: 2,
                        px: 1,
                        py: 0.5,
                      }}
                    >
                      <MaterialTypography variant="caption" colr="text" noWrap>
                        {file.name}
                      </MaterialTypography>
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={() => handleDeleteAttachment(index)}
                      >
                        <DeleteIcon fontSize="small" color="error" />
                      </IconButton>
                    </Stack>
                  ))}
                </>
              ) : (
                <>
                  <Stack
                    // key={index}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      px: 1,
                      py: 0.5,
                    }}
                  >
                    <MaterialTypography variant="caption" colr="text" noWrap>
                      {subTask.attachments.split("/").pop(0)}
                    </MaterialTypography>
                    {view == false ? (
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={handledeleteattach}
                      >
                        <DeleteIcon fontSize="small" color="error" />
                      </IconButton>
                    ) : (
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={() => handleview(subTask.attachments)}
                      >
                        <Visibility fontSize="small" color="success" />
                      </IconButton>
                    )}
                  </Stack>
                </>
              )}
            </Stack>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default SubtaskAddForm;
